// AB   ZIP-016
// Best Sellers Collection - Fetch and display best-selling products

/**
 * Fetches best-selling products from collection and displays them
 */
function fetchBestSellers() {
  // Get collection info first to check collection-specific interaction
  const collectionInfoEl = document.querySelector('[data-collection-info]');
  if (!collectionInfoEl) return;
  
  let collectionData;
  try {
    collectionData = JSON.parse(collectionInfoEl.textContent);
  } catch (error) {
    console.error('Error parsing collection data:', error);
    return;
  }
  
  const collectionHandle = collectionData.collectionHandle;
  if (!collectionHandle) return;
  
  // Check if user has interacted with filters/sorting on THIS specific collection
  const interactedCollections = sessionStorage.getItem('hasInteractedWithFilters') || '';
  const collectionHandles = interactedCollections.split(',').filter(handle => handle);
  
  // Only skip if the user has actively interacted with filters/sorting on this collection
  if (collectionHandles.includes(collectionHandle)) {
    return;
  }
  
  // Construct the URL to fetch best-selling products
  const fetchUrl = `/collections/${collectionHandle}?sort_by=best-selling`;
  
  // Get the grid container and loading element
  const gridContainer = document.querySelector('[data-best-sellers-grid]');
  const bestSellersBlock = document.querySelector('[data-best-sellers-block]');
  
  if (!gridContainer || !bestSellersBlock) return;
  
  // Show the loading spinner first
  bestSellersBlock.classList.add('variant-visible');
  
  // Fetch the collection page
  fetch(fetchUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(html => {
      // Parse the HTML response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the main collection grid
      const sourceGrid = doc.querySelector('#Huratips-Loop');
      if (!sourceGrid) {
        // Try alternative selectors
        const altGrid = doc.querySelector('.grid') || 
                       doc.querySelector('[data-products-grid]') ||
                       doc.querySelector('.product-grid');
        if (!altGrid) {
          throw new Error('Could not find products grid in fetched HTML');
        }
      }
      
      const gridToUse = sourceGrid || doc.querySelector('.grid');
      
      // Try multiple selectors to find product items
      let productItems = gridToUse.querySelectorAll('.grid-item.product-item');
      
      // Fallback selectors if the first one doesn't work
      if (productItems.length === 0) {
        productItems = gridToUse.querySelectorAll('.product-item');
      }
      if (productItems.length === 0) {
        productItems = gridToUse.querySelectorAll('.grid-item');
      }
      if (productItems.length === 0) {
        productItems = gridToUse.querySelectorAll('[data-grid-item]');
      }
      
      // Filter out any featured image blocks or non-product items
      const actualProducts = Array.from(productItems).filter(item => {
        // Skip featured image blocks
        if (item.classList.contains('product-item--featured-image')) {
          return false;
        }
        // Must have a product link
        const productLink = item.querySelector('[data-product-link]') || 
                           item.querySelector('a[href*="/products/"]') ||
                           item.querySelector('.product-link') ||
                           item.querySelector('.product-item__link');
        return productLink !== null;
      });
      
      const first4Products = actualProducts.slice(0, 4);
      
      if (first4Products.length === 0) {
        throw new Error('No valid products found in the collection');
      }
      
      // If we have less than 4 products, try to get more from the original list
      if (first4Products.length < 4 && productItems.length > first4Products.length) {
        // Add more products from the original list if available
        const remainingItems = Array.from(productItems).slice(actualProducts.length);
        for (let item of remainingItems) {
          if (first4Products.length >= 4) break;
          
          // Basic check - if it has any link, include it
          const hasLink = item.querySelector('a[href]');
          if (hasLink) {
            first4Products.push(item);
          }
        }
      }
      
      // Final fallback - if we still don't have enough, just take the first items regardless
      if (first4Products.length < 4 && productItems.length > 0) {
        const finalItems = Array.from(productItems).slice(0, 4);
        first4Products.length = 0; // Clear array
        first4Products.push(...finalItems);
      }
      
      // Clear the loading spinner
      gridContainer.innerHTML = '';
      
      // Add the products to our grid
      const productHandles = [];
      first4Products.forEach((productItem, index) => {
        // Clone the product item
        const clonedItem = productItem.cloneNode(true);
        
        // Clean up any unprocessed Liquid tags or problematic style/link elements
        // Remove any link/style tags that contain Liquid template syntax
        const problematicLinks = clonedItem.querySelectorAll('link[href*="{{"], link[href*="%7B%7B"]');
        problematicLinks.forEach(link => link.remove());
        
        const problematicStyles = clonedItem.querySelectorAll('style:not([data-keep])');
        problematicStyles.forEach(style => {
          // Only remove if it contains Liquid syntax
          if (style.textContent.includes('{{') || style.textContent.includes('{%')) {
            style.remove();
          }
        });
        
        // Remove any inline style attributes that contain Liquid syntax
        const elementsWithInlineStyles = clonedItem.querySelectorAll('[style*="{{"], [style*="{%"]');
        elementsWithInlineStyles.forEach(el => el.removeAttribute('style'));
        
        // Extract product handle for duplicate hiding - try multiple selectors
        let productLink = clonedItem.querySelector('[data-product-link]') || 
                         clonedItem.querySelector('a[href*="/products/"]') ||
                         clonedItem.querySelector('.product-link') ||
                         clonedItem.querySelector('.product-item__link') ||
                         clonedItem.querySelector('a[href]');
        
        if (productLink) {
          const href = productLink.getAttribute('data-product-link') || 
                      productLink.getAttribute('href') || 
                      productLink.href;
          
          if (href) {
            const handleMatch = href.match(/\/products\/([^/?#]+)/);
            if (handleMatch) {
              productHandles.push(handleMatch[1]);
            }
          }
        }
        
        // Add to grid
        gridContainer.appendChild(clonedItem);
      });
      
      // Mark as loaded
      bestSellersBlock.classList.add('products-loaded');
      
      // Store product handles for duplicate hiding
      if (productHandles.length > 0) {
        // Create data element for duplicate hiding
        const dataEl = document.createElement('script');
        dataEl.type = 'application/json';
        dataEl.setAttribute('data-best-sellers-ids', '');
        dataEl.textContent = JSON.stringify({
          productIds: '', // We don't have IDs from HTML parsing
          productHandles: productHandles.join(',')
        });
        bestSellersBlock.appendChild(dataEl);
        
        // Initialize duplicate hiding
        setTimeout(() => {
          hideDuplicateBestSellers();
        }, 100);
      }
    })
    .catch(error => {
      console.error('Error fetching best sellers:', error);
      
      // Hide the loading spinner and show error message
      gridContainer.innerHTML = `
        <div class="best-sellers-error" style="text-align: center; padding: 20px; grid-column: 1 / -1;">
          <p style="color: #666; margin: 0;">Unable to load best sellers</p>
        </div>
      `;
      bestSellersBlock.classList.add('products-loaded');
    });
}

/**
 * Checks if the current URL has any active filters or sorting
 */
function hasActiveFiltersOrSorting() {
  const urlParams = new URLSearchParams(window.location.search);
  
  // Check for filter parameters (filter.v, filter.p, etc.)
  for (let [key, value] of urlParams.entries()) {
    if (key.startsWith('filter.')) {
      return true;
    }
  }
  
  // Check for any sort_by parameter (including best-selling)
  const sortBy = urlParams.get('sort_by');
  if (sortBy && sortBy !== '') {
    return true;
  }
  
  return false;
}

/**
 * Marks the current collection as having had filter/sort interaction
 */
function markCollectionAsInteracted() {
  const collectionInfoEl = document.querySelector('[data-collection-info]');
  if (!collectionInfoEl) return;
  
  let collectionData;
  try {
    collectionData = JSON.parse(collectionInfoEl.textContent);
  } catch (error) {
    return;
  }
  
  const collectionHandle = collectionData.collectionHandle;
  if (!collectionHandle) return;
  
  // Get current list of interacted collections
  const interactedCollections = sessionStorage.getItem('hasInteractedWithFilters') || '';
  const collectionHandles = interactedCollections.split(',').filter(handle => handle);
  
  // Add current collection if not already in the list
  if (!collectionHandles.includes(collectionHandle)) {
    collectionHandles.push(collectionHandle);
    sessionStorage.setItem('hasInteractedWithFilters', collectionHandles.join(','));
  }
}

/**
 * Removes the current collection from the interacted list if no filters/sorting are active
 * Should be called on page load to check current URL state
 */
function checkAndClearCollectionInteraction() {
  const collectionInfoEl = document.querySelector('[data-collection-info]');
  if (!collectionInfoEl) return;
  
  let collectionData;
  try {
    collectionData = JSON.parse(collectionInfoEl.textContent);
  } catch (error) {
    return;
  }
  
  const collectionHandle = collectionData.collectionHandle;
  if (!collectionHandle) return;
  
  // Check current URL state
  if (hasActiveFiltersOrSorting()) {
    // Filters/sorting active in URL, keep in interacted list (but don't add if not there)
    // This handles page refreshes with filters already applied
    return;
  }
  
  // No filters/sorting in URL, remove from interacted list
  const interactedCollections = sessionStorage.getItem('hasInteractedWithFilters') || '';
  let collectionHandles = interactedCollections.split(',').filter(handle => handle);
  
  // Remove current collection from the list
  const originalLength = collectionHandles.length;
  collectionHandles = collectionHandles.filter(handle => handle !== collectionHandle);
  
  // Only update sessionStorage if something changed
  if (originalLength !== collectionHandles.length) {
    if (collectionHandles.length > 0) {
      sessionStorage.setItem('hasInteractedWithFilters', collectionHandles.join(','));
    } else {
      sessionStorage.removeItem('hasInteractedWithFilters');
    }
  }
}

/**
 * Hides bestseller products from the main collection grid to avoid duplicates
 * Reads product handles from data-best-sellers-ids and hides matching products in #Huratips-Loop
 */
function hideDuplicateBestSellers() {
  'use strict';
  
  // Get the best sellers data
  const bestSellersDataEl = document.querySelector('[data-best-sellers-ids]');
  if (!bestSellersDataEl) return;
  
  try {
    const bestSellersData = JSON.parse(bestSellersDataEl.textContent);
    const productHandles = bestSellersData.productHandles.split(',').filter(handle => handle);
    
    if (productHandles.length === 0) return;
    
    // Determine how many products to hide based on screen size
    // Desktop (1280px+): hide 3 products, Mobile: hide 4 products
    const isDesktop = window.innerWidth >= 1280;
    const productsToHide = isDesktop ? 3 : 4;
    const handlesToHide = productHandles.slice(0, productsToHide);
    
    // Get the main product grid
    const mainGrid = document.querySelector('#Huratips-Loop');
    if (!mainGrid) return;
    
    // Find and hide duplicate products in the main grid
    handlesToHide.forEach(function(handle) {
      // Look for product items with this handle
      const productItems = mainGrid.querySelectorAll('.grid-item.product-item');
      
      productItems.forEach(function(item) {
        // Check if this product's link contains the handle
        const productLink = item.querySelector('[data-product-link]') || item.querySelector('a[href*="/products/"]');
        if (productLink) {
          const linkUrl = productLink.getAttribute('data-product-link') || productLink.href;
          
          if (linkUrl) {
            // Normalize both URLs by decoding to handle special characters (™, ®, etc.)
            const decodedUrl = decodeURIComponent(linkUrl.toLowerCase());
            const decodedHandle = decodeURIComponent(handle.toLowerCase());
            
            // Check if URL contains the product handle
            if (decodedUrl.includes('/products/' + decodedHandle)) {
              item.style.display = 'none';
              item.setAttribute('data-hidden-bestseller', 'true');
            }
          }
        }
      });
    });
  } catch (error) {
    console.error('Error hiding bestseller duplicates:', error);
  }
}

/**
 * Unhides bestseller products when filters/sorting is applied
 */
function unhideBestsellerDuplicates() {
  const mainGrid = document.querySelector('#Huratips-Loop');
  if (!mainGrid) return;
  
  const hiddenItems = mainGrid.querySelectorAll('[data-hidden-bestseller="true"]');
  hiddenItems.forEach(function(item) {
    item.style.display = '';
    item.removeAttribute('data-hidden-bestseller');
  });
}

/**
 * Initialize the bestseller functionality
 */
function initBestSellers() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      checkAndClearCollectionInteraction();
      fetchBestSellers();
    });
  } else {
    checkAndClearCollectionInteraction();
    fetchBestSellers();
  }
  
  // Listen for popstate (browser back/forward)
  window.addEventListener('popstate', function() {
    if (hasActiveFiltersOrSorting()) {
      markCollectionAsInteracted();
    } else {
      checkAndClearCollectionInteraction();
      fetchBestSellers();
    }
  });
  
  // Hide variant and unhide duplicates when filters are applied
  const filterForm = document.querySelector('[data-collection-filters-form]');
  if (filterForm) {
    // Listen for any change in the filter form
    filterForm.addEventListener('change', function() {
      const bestSellersBlock = document.querySelector('[data-best-sellers-block]');
      if (bestSellersBlock) {
        bestSellersBlock.classList.remove('variant-visible');
        bestSellersBlock.style.display = 'none'; // Immediately hide
      }
      unhideBestsellerDuplicates();
    });
  }
  
  // Hide variant and unhide duplicates when sorting is changed
  const sortLinks = document.querySelectorAll('[data-sort-link]');
  sortLinks.forEach(function(sortLink) {
    sortLink.addEventListener('click', function(e) {
      const bestSellersBlock = document.querySelector('[data-best-sellers-block]');
      if (bestSellersBlock) {
        bestSellersBlock.classList.remove('variant-visible');
        bestSellersBlock.style.display = 'none'; // Immediately hide
      }
      unhideBestsellerDuplicates();
    });
  });
  
  // Re-run when window is resized (debounced)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // First, show all hidden items
      unhideBestsellerDuplicates();
      // Then re-hide based on new screen size
      setTimeout(hideDuplicateBestSellers, 100);
    }, 250);
  });
  
  // Watch for filter updates and infinite scroll
  const productsContainer = document.querySelector('[data-products-grid]');
  if (productsContainer) {
    const observer = new MutationObserver(function(mutations) {
      // Check if this is a filter update (products container changed)
      const isFilterUpdate = mutations.some(mutation => 
        mutation.target === productsContainer && mutation.addedNodes.length > 0
      );
      
      if (isFilterUpdate) {
        // Filter AJAX update completed, check URL state
        if (hasActiveFiltersOrSorting()) {
          markCollectionAsInteracted();
        } else {
          checkAndClearCollectionInteraction();
          fetchBestSellers();
        }
      } else if (window.Ajaxinate) {
        // Infinite scroll - just re-hide duplicates
        setTimeout(hideDuplicateBestSellers, 100);
      }
    });
    
    observer.observe(productsContainer, { childList: true });
    
    // Also watch the main grid for infinite scroll
    const mainGrid = document.querySelector('#Huratips-Loop');
    if (mainGrid && mainGrid !== productsContainer) {
      const gridObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0 && window.Ajaxinate) {
            setTimeout(hideDuplicateBestSellers, 100);
          }
        });
      });
      gridObserver.observe(mainGrid, { childList: true });
    }
  }
}

// Auto-initialize when script loads
//initBestSellers();